import styles from "./Spinner.module.scss";

interface Props {
	size: "small" | "medium" | "large";
}

const Spinner: React.FC<Props> = ({ size }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			className={`${styles.spinner} ${size ? styles[size] : ""}`}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C8.50822 16 8.51644 16 8.52466 16H8.5V14.8571C4.7129 14.8571 1.64286 11.7871 1.64286 8C1.64286 4.2129 4.7129 1.14286 8.5 1.14286V0Z"
				fill="url(#paint0_linear_545_23980)"
			/>
			<path
				d="M16.5 8C16.5 12.2261 13.2231 15.6869 9.07151 15.9799C8.7567 16.0021 8.5 15.7442 8.5 15.4286C8.5 15.113 8.75673 14.8596 9.07126 14.8337C12.5911 14.5434 15.3571 11.5947 15.3571 8C15.3571 4.2129 12.2871 1.14286 8.5 1.14286V0C12.9183 0 16.5 3.58172 16.5 8Z"
				fill="url(#paint1_linear_545_23980)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_545_23980"
					x1="0.5"
					y1="16"
					x2="0.5"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#129DFA" stopOpacity="0" />
					<stop offset="0.0476827" stopColor="#129DFA" stopOpacity="0" />
					<stop offset="0.952483" stopColor="#129DFA" />
					<stop offset="1" stopColor="#129DFA" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_545_23980"
					x1="8.5"
					y1="16"
					x2="8.5"
					y2="0"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#129DFA" />
					<stop offset="0.0476827" stopColor="#129DFA" />
					<stop offset="0.952483" stopColor="#129DFA" />
					<stop offset="1" stopColor="#129DFA" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default Spinner;
